/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Break any text into its characters and inspect each one — code point, Unicode value, and UTF-8 bytes. Great for debugging encoding issues.`)
};

const es_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide cualquier texto en sus caracteres e inspecciona cada uno: punto de código, valor Unicode y bytes UTF-8. Excelente para depurar problemas de codificación.`)
};

const de_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zerlegen Sie beliebigen Text in seine Zeichen und untersuchen Sie jedes einzelne — Codepunkt, Unicode-Wert und UTF-8-Bytes. Ideal zur Fehlersuche bei Kodierungsproblemen.`)
};

const nl_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breek tekst op in karakters en controleer elk karakter — codepunt, Unicode-waarde en UTF-8-bytes. Ideaal voor het debuggen van coderingsfouten.`)
};

const fr_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décomposez n'importe quel texte en ses caractères et inspectez chacun — point de code, valeur Unicode et octets UTF-8. Parfait pour déboguer les problèmes d'encodage.`)
};

const it_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi qualsiasi testo nei suoi caratteri e ispeziona ognuno — punto di codice, valore Unicode e byte UTF-8. Ottimo per il debug dei problemi di codifica.`)
};

const pt_br2_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida qualquer texto em seus caracteres e inspecione cada um — ponto de código, valor Unicode e bytes UTF-8. Ótimo para depurar problemas de codificação.`)
};

const pt_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida qualquer texto nos seus caracteres e inspecione cada um — ponto de código, valor Unicode e bytes UTF-8. Ótimo para depurar problemas de codificação.`)
};

const ja_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「任意のテキストを文字に分割し、各文字を調べます。コードポイント、Unicode 値、UTF-8 バイトを確認できます。エンコーディングの問題のデバッグに最適です。」`)
};

const zh_ci_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将任意文本拆分为字符并逐一检查——码点、Unicode 值和 UTF-8 字节。非常适合调试编码问题。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_intro", locale)
	if (locale === "en") return en_ci_intro(inputs)
	if (locale === "es") return es_ci_intro(inputs)
	if (locale === "de") return de_ci_intro(inputs)
	if (locale === "nl") return nl_ci_intro(inputs)
	if (locale === "fr") return fr_ci_intro(inputs)
	if (locale === "it") return it_ci_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ci_intro(inputs)
	if (locale === "pt") return pt_ci_intro(inputs)
	if (locale === "ja") return ja_ci_intro(inputs)
	return zh_ci_intro(inputs)
};